import InitialsAvatar from "../../util/name_initial";
import useTranslation from "../../i18n/useTranslation";

export default function TeamHeader({ team, activeSeasonData, division, colors }) {

    const { t } = useTranslation();

    return (
        <>
            <div
                className="row"
                style={{
                    fontFamily: "'Poppins', sans-serif",
                }}
            >
                <div className="col-12 col-sm-6 col-md-12">
                    <div className="info-box mb-3">

                        <div className="info-box-content">
                            <div
                                className="d-flex align-items-center"
                                style={{ gap: "10px", paddingTop: "10px" }}
                            >
                                <InitialsAvatar
                                    name={team.teamName}
                                    size={50}
                                    backgroundColor={colors.primary}
                                    textColor={colors.textOnPrimary}
                                />

                                <div style={{ fontSize: "16px" }}>
                                    {team.teamName}
                                </div>
                            </div>
                        </div>

                        <div className="info-box-content">
                            <span className="info-box-number">
                                {t("teamHeader.division")}
                            </span>

                            <span className="info-box-text">
                                {division.name}
                            </span>
                        </div>

                        <div className="info-box-content">
                            <span className="info-box-number">
                                {t("teamHeader.season")}
                            </span>

                            <span className="info-box-text">
                                {activeSeasonData.name}
                            </span>
                        </div>

                        <div className="info-box-content">
                            <span className="info-box-number">
                                {t("teamHeader.players")}
                            </span>

                            <span className="info-box-text">
                                {team.team.players.length}
                            </span>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}